import styled from 'styled-components';
import { AvForm } from 'availity-mobx-reactstrap-validation';
import { boxShadow } from 'js/config/style';

export default styled(AvForm)`
  background: white;
  box-shadow: ${boxShadow};
  border-radius: 0.25rem;
  padding: 2rem;
  margin-bottom: 2rem;
`;
